import * as z from "zod";

export const duplicateAutomation = {
  name: "duplicateAutomation" as const,
  input: z.object({ automationId: z.string() }),
  output: z.object({ automationId: z.string() }),
};
